
export default {
  name: 'home',
  components: {

  },
  data() {
    return {
      shows: false,
      list: [],
      paymentState: {
        '0': '不需要支付',
        '1': '支付成功',
        '2': '账户入账成功',
        '3': '等待打款',
        '4': '打款失败-已退回余额'
      },
      navList: [
        {
          id: '-1',
          name: '全部'
        },
        {
          id: '11',
          name: '待打款'
        },
        {
          id: '1',
          name: '待审核'
        },
        {
          id: '2',
          name: '审核通过'
        },
        {
          id: '3',
          name: '审核失败'
        },
        {
          id: '4',
          name: '打款失败'
        }
      ],
      navState: {
        1: '待审核',
        2: '审核通过',
        3: '审核失败',
        4: '打款失败'

      },
      params: {
        pageNumber: 1,
        pageSize: 20,
        state: '-1'
      },
      lastPage: false
    }
  },
  created() {
  },
  mounted: function () {
    this.getList()
  },
  methods: {
    getBusinessInfo: function (item) {
      this.apiGet('/h5/api/user/getBusinessInfos', { orderId: item.id ,businessId:item.b_id}, res => {
        if (res.state) {
          this.datas = res.data

          this.shows = true
        } else {
        }
      })
    },
    changeTable: function (id) {
      this.params.state = id
      this.params.pageNumber = 1
      this.list = []
      this.lastPage = false
      this.getList()
    },
    load() {
      setTimeout(d => {
        this.getList()
      }, 100)
    },
    toHb: function () {
      this.$message('正在开发')
    },
    toLinks: function () {
      this.$router.push({ path: '/links' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },
    toMy: function () {
      this.$router.push({ path: '/my' })
    },
    toHome: function () {
      this.$router.push({ path: '/home' })
    },
    toBindAli: function () {
      this.$router.push({ path: '/bindAli' })
    },

    toList: function () {
      this.$router.push({ path: '/list' })
    },

    backPage: function () {
      window.history.go(-1)
    },
    getList: function () {
      let params = JSON.stringify(this.params)
      params = JSON.parse(params)
      if (params.state == -1) {
        params.state = ''
      }
      if (params.state == 11) {
        params.payment_state = '3'
        params.state = ''
      } else {
        params.payment_state = ''
      }
      if (this.lastPage) {
        return
      }

      this.apiGet('/h5/api/user/withdrawal/logList', params, res => {
        this.lastPage = true;

        if (res.state) {
          this.params.pageNumber++
          this.list = this.list.concat(res.data.list)
          // this.lastPage = res.data.lastPage
          setTimeout(d=>{
            this.lastPage = res.data.lastPage;
          },500)
        } else {
          this.$message(res.msg)
        }
      })
    }

  }
}



// WEBPACK FOOTER //
// ./src/views/withdrawal-record/withdrawal-record.js